var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// React
import React from 'react';
// Material ui
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
// Models
import Box from '@material-ui/core/Box/Box';
/**
 * CheckboxForm component
 */
var CheckboxForm = function (props) {
    /** Components properties */
    var id = props.id, label = props.label, options = props.options, error = props.error, required = props.required, initialValue = props.initialValue, onChange = props.onChange, helperText = props.helperText, visible = props.visible, reset = props.reset;
    /** Component states */
    var _a = React.useState(initialValue || []), stateValue = _a[0], setStateValue = _a[1];
    React.useEffect(function () {
        if (reset) {
            setStateValue([]);
        }
    }, [reset]);
    /**
     * Handke checkboxes change
     * @param checkboxValue
     */
    var handleCheckboxListChange = function (checkboxValue) {
        var alReadyChecked = stateValue.includes(checkboxValue);
        var newValue = __spreadArrays(stateValue);
        if (alReadyChecked) {
            var valueIndex = stateValue.indexOf(checkboxValue);
            if (valueIndex > -1) {
                newValue.splice(valueIndex, 1);
            }
        }
        else {
            newValue.push(checkboxValue);
        }
        setStateValue(newValue);
        onChange('keyValue', [id, newValue]);
    };
    if (!visible) {
        return null;
    }
    // Render
    return (React.createElement(FormControl, { required: required, error: error, margin: "normal" },
        label ?
            React.createElement(FormLabel, { component: "label" }, label)
            : undefined,
        React.createElement(FormGroup, null,
            options.map(function (option) {
                return React.createElement(CheckBoxControl, { checked: stateValue.includes(option.value), key: option.value, value: option.value, label: option.label, onChange: handleCheckboxListChange });
            }),
            error
                ? React.createElement(FormHelperText, null, helperText)
                : undefined)));
};
/**
 * Checkbox control
 * @param checked
 * @param label
 * @param onChange
 * @param value
 */
var CheckBoxControl = function (_a) {
    var checked = _a.checked, label = _a.label, onChange = _a.onChange, value = _a.value;
    /**
     * Handle change for checkbox update
     */
    var handleChange = function () {
        onChange(value);
    };
    return React.createElement(Box, { marginTop: 2, marginBottom: 2 },
        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: checked, value: value, onChange: handleChange }), label: React.createElement("span", { dangerouslySetInnerHTML: { __html: label } }) }));
};
export default CheckboxForm;
//# sourceMappingURL=CheckboxForm.js.map